@if (icon().file) {
  <img alt="subject-icon" src="/assets/new-ui/subject-icon/{{ icon().file }}" />
}
